import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { Constants } from "../../../constants/constants";
import { PermissionAction } from "../../../constants/enums";
import { TranslateRequest } from "../../../models/translations-model";
import { PermissionsService } from "../../../services";
import { TranslationsService } from "../../../services/translations-service";

@Component({
  selector: "adaa-translation",
  imports: [],
  templateUrl: "./translation.html",
  styleUrl: "./translation.scss",
})
export class TranslationComponent {
  @Input() originalText: string | undefined;
  @Input() translatedText: string | undefined;
  showOriginal: boolean = true;

  readonly translateService = inject(TranslationsService);
  readonly trasnlate = inject(TranslateService);
  readonly permissionService = inject(PermissionsService);
  @Input() type: string = "";

  @Output() translationDone = new EventEmitter<{ type: string; text: string }>();

  public toggleText() {
    if (!this.originalText?.trim()) return;

    this.showOriginal = !this.showOriginal;

    if (!this.showOriginal) {
      if (this.translatedText) {
        this.translationDone.emit({ type: this.type, text: this.translatedText });
      } else {
        this.translateService.getTranslation(this._prepareModel(this.originalText)).subscribe((translated) => {
          this.translatedText = translated.responseData?.translatedText;
          this.translationDone.emit({ type: this.type, text: this.translatedText });
        });
      }
    } else {
      this.translationDone.emit({ type: this.type, text: this.originalText });
    }
  }

  public get displayText(): string {
    return this.showOriginal ? this.originalText || "" : this.translatedText || "";
  }

  public get buttonLabel(): string {
    return this.showOriginal
      ? this.trasnlate.instant("common.form.button.translate")
      : this.trasnlate.instant("common.form.button.show_original");
  }

  private _prepareModel(data: string) {
    const request: TranslateRequest = {
      text: data,
      source: "ar",
      target: "en",
    };
    return request;
  }

  public checkPermissions() {
    const permission = this.permissionService.hasPermission([
      {
        permissionAction: PermissionAction.execute,
        objectTypeId: Constants.CONSTANT_PERMISSIONS.INSTANT_TRANSLATIONS,
      },
    ]);
    return permission;
  }
}
